import { Image, useMediaQuery, Text } from '@lounge-fe/ui-kit'
import { HeroImageProps } from './types'
import classNames from 'classnames'

export const HeroImage = ({
  title,
  heroImage,
  heroImageDesktop,
  isTitlePrimary,
  heroImageOverlay,
}: HeroImageProps) => {
  const isDesktop = useMediaQuery(({ screens }) => `(min-width: ${screens.sm})`)
  const image = isDesktop
    ? heroImageDesktop || heroImage
    : heroImage || heroImageDesktop

  if (!image) {
    return (
      <div className="my-6 flex items-center justify-center">
        <Text
          variant="title-five"
          as={isTitlePrimary ? 'h1' : 'h3'}
          className="text-center"
        >
          {title}
        </Text>
      </div>
    )
  }

  return (
    <div className="collection-hero-image relative w-full h-full">
      <div
        className={classNames(
          'collection-hero-image__image h-full',
          heroImageOverlay && 'overlay',
        )}
      >
        <Image
          src={image.src}
          alt={image.alt}
          className="w-full h-full object-cover max-h-[248px] sm:max-h-[440px]"
          width={image.width}
          height={image.height}
          loading="eager"
          fetchPriority="high"
        />
      </div>
      <div className="collection-hero-image__text absolute inset-0 flex items-center justify-center">
        <Text
          variant={isDesktop ? 'title-three' : 'title-five'}
          as={isTitlePrimary ? 'h1' : 'h3'}
          className="text-center text-inverse"
        >
          {title}
        </Text>
      </div>
    </div>
  )
}
